var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"title":_vm.tooltipTitle(_vm.time),"data-placement":_vm.tooltipPlacement,"data-container":"body"}},[_vm._v("\n  "+_vm._s(_vm.timeFormated(_vm.time))+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202207e1","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
// module id = null
// module chunks = 